<template>
  <div class="search-header" :style="{height: !showList ? 'auto' : '100vh'}">
    <div class="header">
      <a-input v-model.trim="value" class="search" :placeholder="$t('cd11be8c92')" @keyup.enter="doSearch(value)" ref="input" @focus="inputFocus">
        <template #prefix>
          <div class="search-logo"></div>
        </template>
        <template #suffix v-if="value.length > 0">
          <div class="clear-logo" @click="clear"></div>
        </template>
      </a-input>
      <div class="myCollect" @click="goToCollect" v-if="showCollect"></div>
      <div class="cancel" @click="cancel()" v-else>{{ $t('625fb26b4b') }}</div>
    </div>
    <div class="list-items" v-if="showList">
      <div class="list-item" v-for="item in realList" :key="item.id" @click.self="doSearch(item.content, true)">
        <div class="label" @click.self="doSearch(item.content, true)">{{ item.content }}</div>
        <div class="close" @click="delHistory(item.id)"></div>
      </div>
      <div class="clearHistory" @click="() => (confirm = true)" v-if="realList.length > 0">{{ $t('3ad3cfa11b') }}</div>
    </div>
    <div class="confirm" v-if="confirm">
      <div class="box">
        <div class="title">{{ $t('da324a561e') }}</div>
        <div class="tool-button">
          <span class="cancel" @click="() => (confirm = false)">{{ $t('625fb26b4b') }}</span>
          <span class="cancel ok" @click="ok">{{ $t('2f4aaddde3') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getHistoryList, clearHistory, saveHistory} from '@/api/apiList'
export default {
  data() {
    return {
      value: '',
      onFocus: false,
      historyList: [],
      confirm: false,
      showCollect: true,
      showList: false
    }
  },
  props: {
    inputValue: {
      type: String,
      default: ''
    }
  },
  watch: {
    inputValue(newValue, oldValue) {
      this.value = newValue
      if (this.inputValue == '') {
        this.showList = true
      }
    },
    showCollect(newValue) {
      if (newValue) {
        this.showList = false
      }
    }
  },
  computed: {
    realList() {
      return this.historyList.slice(-3)
    }
  },
  methods: {
    clear() {
      this.$parent.value = ''
      this.value = ''
      if (this.showCollect) {
        this.value = ''
        this.cancel()
      } else {
        this.showList = true
        this.showCollect = false
      }
    },
    cancel() {
      this.showList = false
      this.showCollect = true
      this.$refs.input.blur()
      this.$Bus.$emit('m-search', '')
    },
    goToCollect() {
      window.location.href = "client://client.html?action=ymtz^webid=2804^mode=new^url="+ location.origin + location.pathname + "/#/collect"
      // this.$router.push(`/collect`)
    },
    inputFocus() {
      this.showList = true
      this.showCollect = false
    },
    ok() {
      this.delHistory('all')
    },
    doSearch(content, isHisroty = false) {
      if (isHisroty) {
        this.$Talog({
          id: `${window.platformPre}_tushuoshuju.sousuo.lishi`
        })
      } else {
        this.$Talog({
          id: `${window.platformPre}_tushuoshuju.sousuo`
        })
      }
      this.$refs.input.blur()
      this.$Bus.$emit('m-search', content, isHisroty)
      this.value = content
      this.showList = false
      this.save()
    },
    async delHistory(id) {
      let res = await clearHistory({
        id
      }).catch(error => {
        this.empty = 'error'
        this.emptyText = $t('866b795eae')
        return
      })
      if (res && res.code === 1) {
        this.confirm = false
        this.getData()
      } else {
        this.empty = 'error'
        this.emptyText = $t('866b795eae')
      }
    },
    async save() {
      const {value} = this
      if (value) {
        let res = await saveHistory({
          content: value
        }).catch(error => {
          this.empty = 'error'
          this.emptyText = $t('866b795eae')
          return
        })
        if (res && res.code === 1) {
          this.getData()
        } else {
          this.empty = 'error'
          this.emptyText = $t('866b795eae')
        }
      }
    },
    async getData() {
      let res = await getHistoryList().catch(error => {
        this.empty = 'error'
        this.emptyText = $t('866b795eae')
        return
      })
      if (res && res.code === 1) {
        let {data} = res
        if (data.length > 0) {
          this.historyList = data
        } else {
          this.historyList = []
          this.empty = 'data'
          this.emptyText = $t('d12f75264c')
        }
      } else {
        this.empty = 'error'
        this.emptyText = $t('866b795eae')
      }
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
<style lang="less" scoped>
/deep/ .search {
  width: calc(100% - 46px);
  height: 36px;
  background: #f7f7f7;
  border-radius: 4px;
  .search-logo {
    width: 20px;
    height: 20px;
    background: url('~@/assets/images/search.svg') no-repeat 100% 100%;
    display: inline-block;
  }
  .clear-logo {
    width: 36px;
    height: 36px;
    background: url('~@/assets/images/search_del.svg') no-repeat 100% 100%;
    background-position: center;
    display: inline-block;
    position: relative;
    left: 11px;
  }
  .ant-input {
    height: 36px;
    padding-left: 32px !important;
    background: #f7f7f7;
    border-radius: 4px;
    border: none;
  }
}
.search-header {
  width: 100%;
  position: fixed;
  height: 70px;
  top: 0;
  background: #fff;
  z-index: 9999;
}
.header {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  background: #fff;
  .myCollect {
    width: 28px;
    height: 28px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.84);
    letter-spacing: 0;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('~@/assets/images/collect-phone.svg') no-repeat 100% 100%;
    margin-right: 4px;
    margin-top: -2px;
  }
  .cancel {
    font-size: 15px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 400;
  }
}

.list-items {
  padding-top: 4px;
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    padding: 0 16px;
    border-bottom: 0.5px solid #eeeeee;
    &:nth-child(1) {
      padding-top: 0;
    }
    .label {
      font-size: 18px;
      color: rgba(0, 0, 0, 0.84);
      letter-spacing: 0;
      line-height: 18px;
      font-weight: 400;
    }
    .close {
      width: 20px;
      height: 20px;
      background: url('~@/assets/images/close.svg') no-repeat 100% 100%;
      display: inline-block;
    }
  }
}
.confirm {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .box {
    width: 280px;
    padding: 20px 16px 16px 16px;
    background: #fff;
    .title {
      height: 48px;
      line-height: 48px;
      color: rgba(0, 0, 0, 0.84);
      text-align: center;
      margin-bottom: 20px;
    }
    .tool-button {
      .cancel {
        width: 120px;
        height: 44px;
        line-height: 44px;
        color: rgba(0, 0, 0, 0.84);
        margin-right: 8px;
        text-align: center;
        background: rgba(0, 0, 0, 0.04);
        display: inline-block;
      }
      .ok {
        color: #ff2436;
        margin-right: 0;
      }
    }
  }
}
.clearHistory {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.84);
  letter-spacing: 0;
  font-weight: 400;
  text-align: center;
  margin-top: 15px;
}
.noData {
  height: 100vh;
}
</style>
